'use client';

import { useEffect, useState } from 'react';
import { BiNetworkChart } from 'react-icons/bi';
import { FaArrowTrendUp } from 'react-icons/fa6';
import { HiOutlineRectangleStack } from 'react-icons/hi2';
import { LuNetwork } from 'react-icons/lu';
import { TbHeartbeat, TbWorldCode } from 'react-icons/tb';
import { VscServerProcess } from 'react-icons/vsc';
import { _zones } from '@/data';
import { Card } from './card';
const randomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
const randomFloat = (min: number, max: number) => Number((Math.random() * (max - min) + min).toFixed(2));
export const Overview = () => {
  const avgUptime = 100; // %
  const filteredServices = [1, 2, 3, 4, 5, 6, 7];
  const [avgResponseTime, setAvgResponseTime] = useState(32); // ms
  const [avgReqPerMinute, setAvgReqPerMinute] = useState(29.5); // req/s
  const [avgExecutionTimePerTask, setAvgExecutionTimePerTask] = useState(44); // ms
  const [avgQueueLatency, setAvgQueueLatency] = useState(17); // ms/msg
  const [avgResourceWorkload, setAvgResourceWorkload] = useState(0.2); // %

  useEffect(() => {
    const interval = setInterval(() => {
      setAvgResponseTime(randomInt(20, 30));
      setAvgReqPerMinute(randomFloat(30, 50));
      setAvgExecutionTimePerTask(randomInt(30, 70));
      setAvgQueueLatency(randomInt(10, 20));
      setAvgResourceWorkload(Number(randomFloat(0.1, 1.5)));
    }, 3000); // every 3 seconds

    return () => clearInterval(interval);
  }, []);
  return <div className='mb-8 grid grid-cols-1 gap-4 md:grid-cols-4'>
      <Card className={{
      container: 'border-health-operational/30 bg-health-operational/10 hover:bg-health-operational/20',
      title: 'text-foreground',
      value: 'text-health-operational',
      icon: 'text-health-operational'
    }} Icon={FaArrowTrendUp} title='Overall Uptime' value={`${avgUptime} %`} />
      <Card className={{
      container: 'border-health-operational/30 bg-health-operational/10 hover:bg-health-operational/20',
      title: 'text-foreground',
      value: 'text-health-operational',
      icon: 'text-health-operational'
    }} Icon={TbHeartbeat} title='Avg Response Time' value={`${avgResponseTime} ms`} />
      <Card className={{
      container: 'border-health-operational/30 bg-health-operational/10 hover:bg-health-operational/20',
      title: 'text-foreground',
      value: 'text-health-operational',
      icon: 'text-health-operational'
    }} Icon={BiNetworkChart} title='Active Services' value={`${filteredServices.length.toString()} / 7`} />
      <Card className={{
      container: 'border-health-maintenance/30 bg-health-maintenance/10 hover:bg-health-maintenance/20',
      title: 'text-foreground',
      value: 'text-health-maintenance',
      icon: 'text-health-maintenance'
    }} Icon={TbWorldCode} title='Zones Online' value={`${_zones.filter(z => z.status === 'operational').length} / ${_zones.length}`} />
      <Card className={{
      container: 'border-health-operational/30 bg-health-operational/10 hover:bg-health-operational/20',
      title: 'text-foreground',
      value: 'text-health-operational',
      icon: 'text-health-operational'
    }} Icon={LuNetwork} title='Avg Requests' value={`${avgReqPerMinute} req/m`} />
      <Card className={{
      container: 'border-health-operational/30 bg-health-operational/10 hover:bg-health-operational/20',
      title: 'text-foreground',
      value: 'text-health-operational',
      icon: 'text-health-operational'
    }} Icon={VscServerProcess} title='Avg Execution Time' value={`${avgExecutionTimePerTask} ms/task`} />
      <Card className={{
      container: 'border-health-operational/30 bg-health-operational/10 hover:bg-health-operational/20',
      title: 'text-foreground',
      value: 'text-health-operational',
      icon: 'text-health-operational'
    }} Icon={HiOutlineRectangleStack} title='Avg Queue Latency' value={`${avgQueueLatency} ms/msg`} />
      <Card className={{
      container: 'border-health-operational/30 bg-health-operational/10 hover:bg-health-operational/20',
      title: 'text-foreground',
      value: 'text-health-operational',
      icon: 'text-health-operational'
    }} Icon={BiNetworkChart} title='Avg workload' value={`${avgResourceWorkload} %`} />
    </div>;
};